import { ROLES } from '@/constants/roles';

export default [
  {
    path: '',
    name: 'priceManagement',
    meta: {
      verticalMenu: {
        title: 'Price Management',
        icon: 'CreditCardIcon',
        isGroup: true
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/price-management/cost-prices/management',
    name: 'cost-prices-management',
    redirect: '/price-management/cost-prices/management/unit-prices',
    meta: {
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN],
      verticalMenu: {
        title: 'Cost Prices',
        icon: 'MinimizeIcon',
        parent: 'priceManagement'
      }
    },
    component: () => import('@/views/pages/price-management/cost-prices/CostPricesManagement.vue'),
    children: [
      // Unit Prices
      {
        path: 'unit-prices',
        name: 'cost-prices-unit-prices',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesUnitPrices/CostsPricesUnit.vue'
          )
      },
      {
        path: 'unit-prices-detail/:importId',
        name: 'cost-prices-unit-prices-detail',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesUnitPrices/CostPricesUnitDetail.vue'
          )
      },
      {
        path: 'unit-prices/create',
        name: 'cost-prices-unit-prices-create',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesUnitPrices/CostPricesUnitForm.vue'
          )
      },
      // Additional Fees
      {
        path: 'additional-fees',
        name: 'cost-prices-additional-fees',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesAdditionalFees/CostPricesAdditionalFees.vue'
          )
      },
      {
        path: 'additional-fees-detail/:providerId/:feeId',
        name: 'cost-prices-additional-fees-detail',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesAdditionalFees/EditCostPricesAdditionalFee.vue'
          )
      },
      {
        path: 'additional-fees/create',
        name: 'cost-prices-additional-fees-create',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesAdditionalFees/CreateCostPricesAdditionalFee.vue'
          )
      },
      // Additional Services
      {
        path: 'additional-services',
        name: 'cost-prices-additional-services',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesAdditionalServices/CostPricesAdditionalServicesProviderSelection.vue'
          )
      },
      {
        path: 'additional-services-detail/:providerId',
        name: 'cost-prices-additional-services-detail',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesAdditionalServices/CostPricesAdditionalServices.vue'
          )
      },
      // Instructions
      {
        path: 'instructions',
        name: 'cost-prices-instructions',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesInstructions/CostPricesInstructions.vue'
          )
      },
      {
        path: 'instructions-detail/:providerId',
        name: 'cost-prices-instructions-detail',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesInstructions/CostPricesInstructionsDetail.vue'
          )
      },
      {
        path: 'consignor-prices',
        name: 'cost-prices-consignor-prices',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesConsignorPrices/CostPricesConsignorPrices.vue'
          )
      },
      {
        path: 'consignor-prices/create',
        name: 'cost-prices-consignor-prices-create',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesConsignorPrices/EditCostPricesConsignorPrice.vue'
          )
      },
      {
        path: 'consignor-prices-detail/:providerId',
        name: 'cost-prices-consignor-prices-detail',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesConsignorPrices/EditCostPricesConsignorPrice.vue'
          )
      },
      {
        path: 'rules',
        name: 'cost-prices-rules',
        component: () =>
          import('@/views/pages/price-management/cost-prices/CostPricesRules/CostPricesRules.vue')
      },
      {
        path: 'rules-detail/:providerId/:ruleId',
        name: 'cost-prices-rules-detail',
        component: () =>
          import('@/views/pages/price-management/cost-prices/CostPricesRules/EditCostPriceRule.vue')
      },
      {
        path: 'rules/create',
        name: 'cost-prices-rules-create',
        component: () =>
          import(
            '@/views/pages/price-management/cost-prices/CostPricesRules/CreateCostPriceRule.vue'
          )
      }
    ]
  },
  {
    path: '/price-management/sale-prices/management',
    name: 'sale-prices-management',
    redirect: '/price-management/sale-prices/management/unit-prices',
    meta: {
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN],
      verticalMenu: {
        title: 'Sale Prices',
        icon: 'MaximizeIcon',
        parent: 'priceManagement'
      }
    },
    component: () => import('@/views/pages/price-management/sale-prices/SalePricesManagement.vue'),
    children: [
      // Unit Prices
      {
        path: 'unit-prices',
        name: 'sale-prices-unit-prices',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesUnitPrices/SalePricesUnit.vue'
          )
      },
      {
        path: 'unit-prices-detail/:importId',
        name: 'sale-prices-unit-prices-detail',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesUnitPrices/SalePricesUnitDetail.vue'
          )
      },
      {
        path: 'unit-prices/create',
        name: 'sale-prices-unit-prices-create',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesUnitPrices/SalePricesUnitForm.vue'
          )
      },
      // Additional Fees
      {
        path: 'additional-fees',
        name: 'sale-prices-additional-fees',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesAdditionalFees/SalePricesAdditionalFees.vue'
          )
      },
      {
        path: 'additional-fees/selection',
        name: 'sale-prices-additional-fees-selection',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesAdditionalFees/SalePricesAdditionalFeesSelection.vue'
          )
      },
      {
        path: 'additional-fees-form/:providerId/:customerId',
        name: 'sale-prices-additional-fees-form',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesAdditionalFees/SalePricesAdditionalFeesForm.vue'
          )
      },
      // Additional Services
      {
        path: 'additional-services',
        name: 'sale-prices-additional-services',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesAdditionalServices/SalePricesAdditionalServicesProviderSelection.vue'
          )
      },
      {
        path: 'additional-services-detail/:providerId',
        name: 'sale-prices-additional-services-detail',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesAdditionalServices/SalePricesAdditionalServices.vue'
          )
      },
      // Instructions
      {
        path: 'instructions',
        name: 'sale-prices-instructions',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesInstructions/SalePricesInstructions.vue'
          )
      },
      {
        path: 'instructions-detail/:providerId/:customerId',
        name: 'sale-prices-instructions-detail',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesInstructions/SalePricesInstructionsDetail.vue'
          )
      },
      // Consignor Prices (Return Fees per Customer & Provider)
      {
        path: 'consignor-prices',
        name: 'sale-prices-consignor-prices',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesConsignorPrices/SalePricesConsignorPrices.vue'
          )
      },
      {
        path: 'consignor-prices/create',
        name: 'sale-prices-consignor-prices-create',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesConsignorPrices/EditSalePricesConsignorPrice.vue'
          )
      },
      {
        path: 'consignor-prices-detail/:providerId/:customerId',
        name: 'sale-prices-consignor-prices-detail',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesConsignorPrices/EditSalePricesConsignorPrice.vue'
          )
      },
      // Conditions
      {
        path: 'rules',
        name: 'sale-prices-rules',
        component: () =>
          import('@/views/pages/price-management/sale-prices/SalePricesRules/SalePricesRules.vue')
      },
      {
        path: 'rules/selection',
        name: 'sale-prices-rules-selection',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesRules/SalePricesRuleSelection.vue'
          )
      },
      {
        path: 'rules-form/:providerId/:customerId',
        name: 'sale-prices-rules-form',
        component: () =>
          import(
            '@/views/pages/price-management/sale-prices/SalePricesRules/SalePricesRuleForm.vue'
          )
      }
    ]
  }
];
